import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Button from '@mui/material/Button';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Header from './components/Header';
import Footer from 'examples/Footer';
import { apiGetNotice, apiDeleteNotice } from '../../../api/notice.api';
import { Buffer } from 'buffer';
import ReactHtmlParser from 'react-html-parser';
import { Divider } from '@mui/material';
import { useData } from '../../../hooks';
import MDAlert from 'components/MDAlert';
import TopNavbar from 'examples/Navbars/TopNavbar';

const NoticeDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const { user, appIsReady } = useData();

  useEffect(() => {
    if (id && appIsReady && user) {
      fetchNotice(id);
    }
  }, [id, user, appIsReady]);

  const fetchNotice = async (noticeid) => {
    setLoading(true);
    try {
      const response = await apiGetNotice(noticeid, user.accessToken);
      if (response && response.content && response.content.data) {
        const decodedContent = Buffer.from(response.content.data).toString('utf8');
        setNotice({ ...response, content: decodedContent });
      } else {
        setNotice(response);
      }
    } catch (error) {
      console.error('Error fetching notice:', error);
    } finally {
      setLoading(false);
    }
  };

  const messageTypeToString = (type) => {
    switch (type) {
      case 1: return '앱공지';
      case 3: return '매뉴얼';
      case 4: return '점주용공지';
      case 5: return '점주용매뉴얼';
      case 6: return '후원사';
      default: return '기타';
    }
  };

  const handleEdit = () => {
    navigate(`/board/edit/${id}`, { state: { notice, messageType: location.state.messageType, page: location.state.page } });
  };

  const handleDelete = () => {
    setShowAlert(true);
  };

  const confirmDelete = async () => {
    setShowAlert(false);
    try {
      const response = await apiDeleteNotice(id, user.accessToken);
      console.log("response=" + response);
      if (response === "success") {
        alert('게시물이 성공적으로 삭제되었습니다.');
        navigate(`/boards?messageType=${location.state.messageType}`);
      } else {
        alert('게시물 삭제에 실패했습니다.');
      }
    } catch (error) {
      console.error('Error deleting notice:', error);
      alert('게시물 삭제 중 오류가 발생했습니다.');
    }
  };

  const handleBack = () => {
    const searchParams = new URLSearchParams();
    searchParams.set('messageType', location.state.messageType);
    navigate(`/boards?${searchParams.toString()}`);
  };

  if (loading) {
    return (
      <DashboardLayout>
        <TopNavbar />
        <Header />
        <MDBox pt={6} pb={3}>
          <MDTypography variant="h4" color="info">
            Loading...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <TopNavbar />
      <Header>
        <MDBox pt={6} pb={3}>
          {notice ? (
            <>
              <MDBox mb={2} display="flex" justifyContent="space-between">
                <MDTypography variant="h4" fontWeight="bold">
                  {messageTypeToString(notice.messageType)}
                </MDTypography>
                <MDBox width={150} display="flex" justifyContent="space-between">
                  <Button mr="$2" variant="contained" color="success" onClick={handleDelete}>
                    삭제
                  </Button>
                  <Button variant="contained" color="success" onClick={handleEdit}>
                    수정
                  </Button>
                </MDBox>
              </MDBox>
              <MDBox mb={2} bgColor='#EFEFEF' padding={1.5} borderRadius={10}>
                <MDBox display="flex" justifyContent="space-between" mb={1}>
                  <MDTypography variant="body1" color="textSecondary">
                    작성자: {notice.creator_id}
                  </MDTypography>
                  <MDTypography variant="body1" color="textSecondary">
                    작성일: {new Date(notice.createdAt).toLocaleDateString()}
                  </MDTypography>
                  <MDTypography variant="body1" color="textSecondary">
                    메시지 타입: {messageTypeToString(notice.messageType)}
                  </MDTypography>
                </MDBox>
                <MDBox display="flex" justifyContent="space-between" mb={1}>
                  {notice.subType && (
                    <MDTypography variant="body1" color="textSecondary">
                      서브 타입: {notice.subType}
                    </MDTypography>
                  )}
                  {notice.orderno && (
                    <MDTypography variant="body1" color="textSecondary">
                      순서: {notice.orderno}
                    </MDTypography>
                  )}
                </MDBox>
                <MDTypography variant="body1" color="textSecondary">
                  제목: {notice.title}
                </MDTypography>
              </MDBox>

              <MDBox mt={3}>
                <MDTypography variant="body1">
                  {ReactHtmlParser(notice.content)}
                </MDTypography>
              </MDBox>
              <MDBox mt={2}>
                <Button variant="contained" color="success" onClick={handleBack}>
                  뒤로 가기
                </Button>
              </MDBox>
            </>
          ) : (
            <MDTypography variant="h4" color="info">
              Notice not found
            </MDTypography>
          )}
        </MDBox>
      </Header>
      <Footer />
      {showAlert && (
        <MDAlert color="info" dismissible>
          <MDBox display="flex" alignItems="center" color="white">
            게시물을 삭제하시겠습니까?
          </MDBox>
          <MDBox display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="success" onClick={confirmDelete} style={{ marginRight: '10px' }}>
              예
            </Button>
            <Button variant="contained" color="error" onClick={() => setShowAlert(false)}>
              아니요
            </Button>
          </MDBox>
        </MDAlert>
      )}
    </DashboardLayout>
  );
}

export default NoticeDetail;
